import styled, { css } from "styled-components";
import { colors } from "../../../base/styled/variables.styled";
import { fontFamilies, textColors, typography, } from "../../../base/styled/typography.style";
export const StyledAccordion = styled.div `
	display: flex;
	flex-direction: column;
	gap: 8px;
	font-family: ${fontFamilies.primary};
	${({ disabled }) => disabled &&
    css `
			opacity: 0.5;
			cursor: not-allowed;
		`}

	.cmp-accordion__item {
    border: ${props => props.isNested ? `solid 1px ${colors.neutral200}` : `solid 2px ${colors.brand200}`};
		border-radius: 8px;
		margin-top: ${(props) => (props.isNested ? "16px" : "0")};
		background-color: ${colors.neutral000};

		${({ isNested, disabled }) => disabled
    ? ""
    : isNested &&
        css `
						& + & {
							margin-top: 16px;
						}
						&:nth-child(n + 6) {
							display: none;
						}
						&:last-child {
							margin-bottom: 0;
						}
				  `}
	}
`;
export const AccordionHeader = styled.div `
	display: flex;
	gap: 12px;
	align-items: center;
	margin: 0;
  padding: ${({ isOpen, isNested }) => isNested ? (isOpen ? '16px 16px 0 16px' : '16px') : '16px'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  background-color: ${({ isOpen }) => isOpen ? colors.brand400 : colors.neutral000};
  border-radius: ${({ isOpen }) => isOpen ? '6px 6px 0 0' : '6px'};
	transition: background-color 0.1s ease, color 0.1s ease;

	.cmp-accordion__panel & {
    background-color: ${colors.neutral000} !important;
	}

	div {
		min-width: 40px;
		min-height: 40px;
		max-width: 40px;
		max-height: 40px;
	}

	span {
		flex: 1;
		${typography.buttonLarge};
		color: ${({ isOpen }) => (isOpen ? colors.neutral000 : colors.neutral800)};
		transition: color 0.1s ease;

		.cmp-accordion__panel & {
			color: ${colors.neutral800} !important;
		}
	}

	svg {
		transition: transform 0.3s ease, color 0.3s ease;
    transform: ${({ isOpen }) => isOpen ? 'rotate(-180deg)' : 'rotate(0)'};
    fill: ${({ isOpen }) => isOpen ? colors.umbuGreen300 : colors.brand500};
		min-width: 24px !important;
		min-height: 24px !important;
		width: 24px !important;
		height: 24px !important;
		margin-left: auto;

		.cmp-accordion__panel & {
      fill: ${colors.brand500} !important;
		}
	}

	&:hover,
	&.pseudo-hover {
		background-color: ${colors.neutral100};

		.cmp-accordion__panel & {
      background-color: ${colors.neutral000} !important;
		}

		span {
			color: ${colors.neutral800};
		}
		svg {
      fill: ${colors.brand500};
		}
	}

	&:focus,
	&.pseudo-focus {
		outline: 3px solid ${colors.brand300};
	}

	&:active,
	&.pseudo-active {
		background-color: ${colors.brand400};

    span {
      color: ${colors.neutral000};
    }

    svg {
      fill: ${colors.umbuGreen300};
    }

		.cmp-accordion__panel & {
      background-color: ${colors.neutral000} !important;

      span {
        color: ${colors.neutral800} !important;
      }

      svg {
        fill: ${colors.brand500} !important;
			}
		}
	}
`;
export const AccordionContent = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isOpen'].includes(prop),
}) `
	padding: ${({ isOpen }) => (isOpen ? "16px" : "0 16px")};
	height: ${({ isOpen }) => (isOpen ? "auto" : "0")};
	overflow: hidden;
	transition: all 0.3s ease;
	opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
	${typography.body1};
	span:not(:is(button *)) {
		${typography.buttonMedium};
		color: ${textColors.secondary};
	}
`;
//# sourceMappingURL=Accordion.style.js.map